export async function cloneCertificateForExport() {
    const node = document.getElementById("noteItems");
    return node ? node.cloneNode(true) : null;
}

export async function cloneContractForExport() {
    const node = document.getElementById("contractContent");
    return node ? node.cloneNode(true) : null;
}
